// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","StoryBoxPlaceholder":"StoryBoxPlaceholder-4pt6bunyywd8x6uacv7qtas19rp1duj2s1z1c71ak76uatk27nyd2uss4hcsbmsbnahwdm58a9p8upsmjaftk73jud38eyw3phmjfsc","Year":"Year-w6e5pfn9s78zz7d1sz3em5rrs2u4arb3qbwnz1tk8n88k68rpkb4n7jwdnt32c1v55ba1pfc6zhw128m1cgaa1pkn37ssajy85ndqs","loading":"loading-4vca6egc1274dduf8bp9yxnnj4tk18cyeyez4yjr2tab1gyatvkdtsanfshxp5meb9bfx1yyxym93rpxmv6fbx8kcnkxsqy752twc9m","pulse":"pulse-24ryd7mrnmz23k5518by35p2pb7vw3jzp1t1eu1vz4f1p8vxqnprqzm2q2wqdkka1mc9cndyb1g7vsd59g9u9hmcftzxq512wb4mrtx"};


//////////////////
// WEBPACK FOOTER
// ./src/views/History/placeholder/StoryBox/StoryBoxPlaceholder.module.scss
// module id = 1659
// module chunks = 0